import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { moduleName } from '../../moduleInfo';
import {
  academicSessionRoute,
  admissionDateRoute,
  getInTouchForm,
  getManagementAppAllSchoolsRoute,
  getSingleBranchDetailRoute,
} from '../../utils/apiRoutes';
import { axiosBuzzOne } from '../../../../axios';

export const getManagementAppAllBranchAsync = createAsyncThunk(
  `${moduleName}/getManagementAppAllBranchAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getManagementAppAllSchoolsRoute(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const createLeadsAsync = createAsyncThunk(
  `${moduleName}/createLeadsAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: getInTouchForm(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const getBranchDetails = createAsyncThunk(
  `${moduleName}/getBranchDetails`,
  async (schoolId) => {
    if (schoolId) {
      try {
        const response = await axiosBuzzOne({
          method: 'GET',
          url: getSingleBranchDetailRoute(schoolId),
        });
        return response.data;
      } catch (error) {
        return error;
      }
    } else {
      return 'empty school id';
    }
  }
);

export const getSessionAsync = createAsyncThunk(
  `${moduleName}/getSession`,
  async ({ schoolId = '' }) => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: academicSessionRoute(schoolId),
      headers: {
        'x-schoolid': schoolId,
      },
    });
    return response.data;
  }
);

export const getAdmissionDatesAsync = createAsyncThunk(
  `${moduleName}/admissionDate/getAdmissionDatesAsync`,
  async ({ schoolId, sessionId }) => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: admissionDateRoute(schoolId, sessionId),
      headers: {
        'x-schoolid': schoolId,
      },
    });
    return response.data.data;
  }
);

export const postSeo = createAsyncThunk(
  `${moduleName}/postSeo`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: `/pwa/scripts/${payload.params}`,
      data: payload.data,
    });
    const data = response.data;
    return data;
  }
);

export const getSeo = createAsyncThunk(
  `${moduleName}/getSeo`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: `/pwa/scripts/${payload.params}`,
    });
    const data = response.data;
    return data;
  }
);

const approvalManagementReducer = createSlice({
  name: `${moduleName}/dashboard`,
  initialState: {
    loading: false,
    allBranch: null,
    schoolSession: [],
    savedClassNames: [],
    data: {},
    error: '',
    metadata: null,
  },
  reducers: {
    storeDashboardSchoolId: (state, action) => {
      state.schoolId = action.payload;
    },
  },
  extraReducers: {
    [getManagementAppAllBranchAsync.pending]: (state) => {
      state.loading = true;
    },
    [getManagementAppAllBranchAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.allBranch = action.payload;
    },
    [getManagementAppAllBranchAsync.rejected]: (state) => {
      state.loading = false;
    },
    [createLeadsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [createLeadsAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createLeadsAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [postSeo.pending]: (state, action) => {
      state.loading = true;
    },
    [postSeo.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [postSeo.rejected]: (state, action) => {
      state.loading = false;
    },
    [getSeo.pending]: (state, action) => {
      state.loading = true;
    },
    [getSeo.fulfilled]: (state, action) => {
      state.loading = false;
      state.metadata = action.payload;
    },
    [getSeo.rejected]: (state, action) => {
      state.loading = false;
    },
    [getBranchDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [getBranchDetails.pending]: (state, action) => {
      state.loading = true;
      state.error = action.payload;
    },
    [getBranchDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getSessionAsync.pending]: (state) => {
      state.loading = true;
    },
    [getSessionAsync.rejected]: (state) => {
      state.loading = false;
      // todo
    },
    [getSessionAsync.fulfilled]: (state, action) => {
      // // console.log('dataPayload', action.payload);
      if (
        action.payload &&
        action.payload.data &&
        Array.isArray(action.payload.data)
      ) {
        state.schoolSession = action.payload.data;
      }
      state.loading = false;
    },
    [getAdmissionDatesAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.schoolClasses = action.payload;
      state.savedClassNames =
        action.payload && Array.isArray(action.payload)
          ? action.payload
              .filter((classEntity) => classEntity.startDate)
              .map((classEntity) => classEntity.className)
          : [];
    },

    [getAdmissionDatesAsync.pending]: (state) => {
      state.error = undefined;
      state.loading = true;
    },
    [getAdmissionDatesAsync.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { storeDashboardSchoolId } = approvalManagementReducer.actions;

export default approvalManagementReducer.reducer;
